export default "__VITE_ASSET__0e0oc4MSW5tEjp58TrfHeg__"